module.exports = __webpack_public_path__ + "static/habegger-0812b695377d713eded71de79a8c5723.png";